module.exports = __webpack_public_path__ + "img/4-3.7c1b6737.svg";